import { computed, inject } from 'vue';
import { useCookies } from 'vue3-cookies';
import { useStore } from 'vuex';

import { GetPlatformNotifications } from '~/constants/getters';
import { SetPlatformNotifications } from '~/constants/mutations';

import { apiGatewayEndpoints } from '~/services/arcane-api-gateway/api-gateway-endpoints';
import { dateTimeIsBetween } from '~/utils/date-utils';

export default () => {
  const store = useStore();
  const arcaneApiGateway = inject('arcaneApiGateway');
  const { cookies } = useCookies();

  const platformNotifications = computed(() => store.getters[`platformNotificationsStore/${GetPlatformNotifications}`]);

  const getPlatformNotifications = async () => {
    try {
      const response = await arcaneApiGateway.get(apiGatewayEndpoints.platform.platformNotifications);

      const closedPlatformNotifications = JSON.parse(cookies.get('closedPlatformNotifications')) || [];
      const availablePlatformNotifications = response.data?.filter(
        (notification) =>
          !closedPlatformNotifications.includes(notification.id) &&
          dateTimeIsBetween(notification.startTime, notification.endTime),
      );

      store.dispatch(`platformNotificationsStore/${SetPlatformNotifications}`, availablePlatformNotifications);

      return response.data;
    } catch (error) {
      console.error('Failed to load platform notifications:', error);
    }
  };

  const deleteNotificationCookies = (id) => {
    const closedPlatformNotifications = JSON.parse(cookies.get('closedPlatformNotifications')) || [];
    const jsonString = JSON.stringify([...closedPlatformNotifications, id]);
    cookies.set('closedPlatformNotifications', jsonString);

    const availablePlatformNotifications = platformNotifications.value.filter((notif) => notif.id !== id);
    store.dispatch(`platformNotificationsStore/${SetPlatformNotifications}`, availablePlatformNotifications);
  };

  return { platformNotifications, getPlatformNotifications, deleteNotificationCookies };
};
